import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { IconButton } from '@awazevr/design-system.components.button'
import { ChevronUp } from '@awazevr/design-system.components.icon'
import { breakpoints } from '@awazevr/design-system.utils.react'
import { useIsMobile } from 'src/utils/hooks/useIsMobile'
import { useHasScrolledPastViewport } from 'src/utils/hooks/useHasScrolledPastViewport'

const DESKTOP_MARGIN = 32
const MOBILE_MARGIN = 24

const ButtonWrapper = styled.div<{ $visible: boolean }>`
  position: fixed;
  bottom: ${DESKTOP_MARGIN}px;
  right: ${DESKTOP_MARGIN}px;
  z-index: 1000;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? '0px' : '12px')});
  pointer-events: ${({ $visible }) => ($visible ? 'auto' : 'none')};
  transition: all 0.3s ease;

  @media (max-width: ${breakpoints[0] - 1}px) {
    bottom: ${MOBILE_MARGIN}px;
    right: ${MOBILE_MARGIN}px;
  }
`

export const BackToTop: React.FC = () => {
  const isVisible = useHasScrolledPastViewport()
  const isMobile = useIsMobile()
  const intl = useIntl()

  const ariaLabel = intl.formatMessage({
    id: 'back-to-top.aria-label',
    defaultMessage: 'Back to top',
  })

  return (
    <ButtonWrapper $visible={isVisible} data-testid="back-to-top">
      <IconButton
        variant="elevated"
        size={isMobile ? 'small' : 'medium'}
        icon={<ChevronUp iconColour="currentColor" />}
        title={ariaLabel}
        aria-label={ariaLabel}
        onClick={() => globalThis.scrollTo({ top: 0, behavior: 'smooth' })}
      />
    </ButtonWrapper>
  )
}
